import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

const Container = styled.div`
  display: flex;
    align-content:flex-start;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: flex-start;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);


`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:250px;
  align-content: flex-start;

  overflow:hidden;

  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

const Coverbg = styled.img`
  
  object-fit: cover;
  align-self:center;
  align-content:flex-start;
  opacity:70%;   
  border: none;
  width:100%;
`;


const Inner01 = styled.div`
  display: flex;
  flex-start;
  flex-direction:column;
  width: 70%;
  height: auto;
  margin-left:10px;
  margin-top:10px;
  justify-content:left;

  z-index:1;

`;


const Subtag = styled.span`
  font-size: 0.9rem;
  color: #8a7700;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 1px;
  justify-content:left;
  margin-left:10px;

`;

const Row = styled.div`
  display: flex;
  flex-direction:row;
`;

const Description = styled.p`
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.4em;
  letter-spacing: .6px;

  
`;
const Paragraph = styled.p`
  font-family:roboto;
  font-size: 0.9rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  z-index:5;

  
`;

const ReusableRecipe = ({title,image,url}) => {

  return(
  <a href= {url}target="_blank"rel="noopener noreferrer"style={{ textDecoration: 'none' }}>
  <Container> 
  <Viz>             
    <Coverbg src= {image} alt=""/>
  </Viz>  
    <Inner01>      
        <Description>{title}</Description>
        <Paragraph>Open the recipe in a new tab.</Paragraph>    
    </Inner01>
  </Container>
  </a>
 );
}
export default ReusableRecipe;
